const VALUES = [
    {display:'Green Bond', value:'Green'},
    {display:'New Clean Renewable Energy - Tax Credit', value:'NCREB'},
    {display:'New Clean Renewable Energy - Direct', value:'NCRED'},
    {display:'Qualified Energy Conservation - Tax Credit', value:'QECB'},
    {display:'Qualified Energy Conservation - Direct', value:'QECBD'}
]

export const MUNI_ENVIRONMENTALS = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdIssueType=' + value
        }
    })

export const MUNI_ENVIRONMENTAL_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))


// WEBPACK FOOTER //
// ./src/twd/values/muni-environmentals.js